import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fda7336"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CmsInvoicesFilters__header" }
const _hoisted_2 = { class: "CmsInvoicesFilters__grid-3" }
const _hoisted_3 = { class: "CmsInvoicesFilters__actions" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_filters_icon = _resolveComponent("filters-icon")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_title, { title: "Накладные на сегодня" }),
      _createVNode(_component_new_button, {
        class: "NewButton--outline",
        onClick: _ctx.toggle
      }, {
        default: _withCtx(() => [
          _createVNode(_component_filters_icon, { class: "CmsInvoicesFilters__icon" }),
          _createTextVNode(" Фильтр ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _withDirectives(_createElementVNode("form", {
      class: "CmsInvoicesFilters",
      onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_the_input, {
            placeholder: "Номер накладной",
            disabled: _ctx.loading,
            value: _ctx.filters.invoiceNumber,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.invoiceNumber) = $event))
          }, null, 8, ["disabled", "value"]),
          _createVNode(_component_the_input, {
            placeholder: "Номер заказа",
            disabled: _ctx.loading,
            value: _ctx.filters.orderNumber,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.orderNumber) = $event))
          }, null, 8, ["disabled", "value"]),
          _createVNode(_component_the_select, {
            class: "mt-2",
            placeholder: "Исключить клиента",
            value: _ctx.filters.notCompanyIds,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.notCompanyIds) = $event)),
            disabled: _ctx.loading || _ctx.data_state.companies.is_loading,
            options: _ctx.data_state.companies.list,
            loading: _ctx.data_state.companies.is_loading,
            failed: _ctx.data_state.companies.is_failed,
            "error-text": "При получении списка произошла ошибка",
            "search-without-refresh": "",
            "can-deselect": "",
            multiselect: ""
          }, null, 8, ["value", "disabled", "options", "loading", "failed"]),
          _createVNode(_component_the_select, {
            placeholder: "Клиент",
            value: _ctx.filters.companyIds,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.companyIds) = $event)),
            disabled: _ctx.loading || _ctx.data_state.companies.is_loading,
            options: _ctx.data_state.companies.list,
            loading: _ctx.data_state.companies.is_loading,
            failed: _ctx.data_state.companies.is_failed,
            "error-text": "При получении списка произошла ошибка",
            "search-without-refresh": "",
            "can-deselect": "",
            multiselect: ""
          }, null, 8, ["value", "disabled", "options", "loading", "failed"]),
          _createVNode(_component_the_select, {
            placeholder: "Вид перевозки",
            value: _ctx.filters.shipmentTypeId,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.shipmentTypeId) = $event)),
            disabled: _ctx.loading,
            options: _ctx.SHIPMENT_TYPES,
            loading: _ctx.loading,
            "can-deselect": ""
          }, null, 8, ["value", "disabled", "options", "loading"]),
          _createVNode(_component_the_select, {
            placeholder: "Наличка",
            value: _ctx.filters.needCashSum,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.needCashSum) = $event)),
            disabled: _ctx.loading,
            options: _ctx.CASH_OPTIONS,
            loading: _ctx.loading,
            "can-deselect": "",
            "select-by": "value"
          }, null, 8, ["value", "disabled", "options", "loading"]),
          _createVNode(_component_the_select, {
            placeholder: "Город отправки",
            value: _ctx.filters.fromCityId,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.fromCityId) = $event)),
            disabled: _ctx.loading || _ctx.data_state.cities.is_loading,
            options: _ctx.data_state.cities.list,
            loading: _ctx.data_state.cities.is_loading,
            failed: _ctx.data_state.cities.is_failed,
            "error-text": "При получении списка городов произошла ошибка",
            "search-without-refresh": "",
            "can-deselect": ""
          }, null, 8, ["value", "disabled", "options", "loading", "failed"]),
          _createVNode(_component_the_select, {
            placeholder: "Город назначения",
            value: _ctx.filters.toCityId,
            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.toCityId) = $event)),
            disabled: _ctx.loading || _ctx.data_state.cities.is_loading,
            options: _ctx.data_state.cities.list,
            loading: _ctx.data_state.cities.is_loading,
            failed: _ctx.data_state.cities.is_failed,
            "error-text": "При получении списка городов произошла ошибка",
            "search-without-refresh": "",
            "can-deselect": ""
          }, null, 8, ["value", "disabled", "options", "loading", "failed"]),
          _createVNode(_component_the_select, {
            placeholder: "Менеджер",
            value: _ctx.filters.managerIds,
            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.managerIds) = $event)),
            disabled: _ctx.loading || _ctx.data_state.managers.is_loading,
            options: _ctx.data_state.managers.list,
            loading: _ctx.data_state.managers.is_loading,
            failed: _ctx.data_state.managers.is_failed,
            "error-text": "При получении списка произошла ошибка",
            "search-by": "name",
            "select-by": "id",
            label: "name",
            onRefresh: _ctx.loadManagers,
            onSearch: _ctx.searchManagers,
            onOptionBySearch: _ctx.unshiftFindedManager,
            "search-without-refresh": "",
            "can-deselect": "",
            multiselect: "",
            "infinite-scroll": "",
            "select-all": "",
            onSelectAll: _ctx.selectAllManagers,
            onDeselectAll: _ctx.deselectAllManagers
          }, null, 8, ["value", "disabled", "options", "loading", "failed", "onRefresh", "onSearch", "onOptionBySearch", "onSelectAll", "onDeselectAll"]),
          _createVNode(_component_the_select, {
            placeholder: "Самопривоз",
            value: _ctx.filters.isSelfDelivery,
            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters.isSelfDelivery) = $event)),
            disabled: _ctx.loading,
            options: _ctx.DELIVERY_OPTIONS,
            loading: _ctx.loading,
            "can-deselect": "",
            "select-by": "value"
          }, null, 8, ["value", "disabled", "options", "loading"]),
          _createVNode(_component_the_select, {
            placeholder: "Самовывоз",
            value: _ctx.filters.isPickup,
            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filters.isPickup) = $event)),
            disabled: _ctx.loading,
            options: _ctx.PICKUP_OPTIONS,
            loading: _ctx.loading,
            "can-deselect": "",
            "select-by": "value"
          }, null, 8, ["value", "disabled", "options", "loading"]),
          _createVNode(_component_checkbox, {
            value: _ctx.filters.isDelaying,
            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filters.isDelaying) = $event)),
            disabled: _ctx.loading,
            label: "Опаздывающие",
            "return-integer": ""
          }, null, 8, ["value", "disabled"]),
          _createVNode(_component_checkbox, {
            value: _ctx.filters.hasWaitListStatuses,
            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filters.hasWaitListStatuses) = $event)),
            disabled: _ctx.loading,
            label: "ЛО",
            "return-integer": ""
          }, null, 8, ["value", "disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_new_button, {
          type: "button",
          disabled: _ctx.loading,
          class: "NewButton--reset mr-3",
          onClick: _ctx.onReset
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Сбросить ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_new_button, {
          type: "submit",
          disabled: _ctx.loading,
          class: "NewButton--search"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" Поиск ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ], 544), [
      [_vShow, _ctx.state.is_open]
    ])
  ], 64))
}